var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.5L5 20.5L19 20.5L19 9.5L14.342 9.5L14.342 14.6924L8.98828 14.6924L8.98828 9.5L5 9.5Z",
    fill: "#E53323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79989 8.09375L11.728 5.25482L14.6562 8.09375L15.5557 7.21976L11.728 3.50063L7.90039 7.21976L8.79989 8.09375Z",
    fill: "#004899"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7285 5.03133L11.7285 12.6865",
    stroke: "#004899",
    strokeWidth: 1.43244
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.a78d8a14991f9bfd82967422a989f321.svg";
export { ForwardRef as ReactComponent };